import { Provider } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
	DATEPICKER_TRANSLATION_CONFIG,
	DatepickerTranslationConfig,
	DEFAULT_DATEPICKER_TRANSLATIONS,
} from '@agilox/ui-common';

export function provideDatepickerTranslationsWithNgxTranslate(): Provider {
	return {
		provide: DATEPICKER_TRANSLATION_CONFIG,
		useFactory: (translateService: TranslateService) => {
			const config: DatepickerTranslationConfig = {
				translations: DEFAULT_DATEPICKER_TRANSLATIONS,
				translateFn: (key: string, params?: any) => {
					return translateService.instant(key, params);
				},
			};
			return config;
		},
		deps: [TranslateService],
	};
}
